import { render, staticRenderFns } from "./EventRequest.vue?vue&type=template&id=6dfe1d7a"
import script from "./EventRequest.vue?vue&type=script&lang=js"
export * from "./EventRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports